/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Extract from T those types that are assignable to U
 */
export enum Extract_PropertyOperation_MeliPublicationDraftOperation_ {
    SALE = 'SALE',
    RENT = 'RENT',
}
